import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';

export const EmptyStateRow = ({ colSpan }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <EmptyPlaceholder
          title={strings.shared.emptyState.title}
          subtitle={strings.shared.emptyState.subtitle}
        />
      </TableCell>
    </TableRow>
  );
};
